import React from "react";

function SolanaHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Unlock the Potential of Solana with Xeer’s Blockchain
                  Solutions
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology specializes in building scalable,
                    high-performance applications on the Solana blockchain,
                    known for its lightning-fast transactions and low fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SolanaHero;
